export const LOGIN_RETURN_PATH_KEY = 'returnPath';
export const ONBOARDING_WIZARD_KEY_PREFIX = 'wb.onboarding.quiz';
export const ONBOARDING_WIZARD_ORDER_PARAMS_KEY = `${ONBOARDING_WIZARD_KEY_PREFIX}.order`;
export const SESSION_STORAGE_KEY = 'wb-hub-session';
